<template>
  <main role="main" class="py-4">
    <b-container fluid="xxl">
      <h5 class="max-title-div">{{  $t("meeting")  }}: <strong>{{ meetingName }}</strong> </h5><br />
      <b-alert :show="!!alertMessage" variant="danger">{{ $t(alertMessage) }}</b-alert>
      <b-table ref="table" :items="tableData" :busy="initLoading" hover show-empty primary-key="uid" :fields="tableFields">
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>

        <template #cell(actions)="row">
          <b-button v-if="row.index !== 0" size="sm" variant="link" @click="row.toggleDetails">
            <b-icon-chevron-up v-if="row.detailsShowing"></b-icon-chevron-up>
            <b-icon-chevron-down v-else></b-icon-chevron-down>
          </b-button>
        </template>

        <template #row-details="row">
          <b-card>
            <MonitorUser :mid="mid" :uid="row.item.uid" :polling="polling"></MonitorUser>
          </b-card>
        </template>
      </b-table>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as meetingService from "@/service/meetingService";
  import * as monitorService from "@/service/monitorService";
  import * as util from "@/service/util";
  import {BvTableFieldArray} from "bootstrap-vue";
  import MonitorUser from "@/components/monitor/MonitorUser.vue";

  @Component({
    components: { MonitorUser }
  })
  export default class MonitorMeeting extends BaseComponent {

    meetingId = 0;
    mid = "";
    meetingName="";

    alertMessage = "";

    initLoading = true;
    tableFields: BvTableFieldArray = [
      {
        key: "uid",
        label: "UID"
      },
      {
        key: "uname",
        label: "Username"
      },
      {
        key: "loss",
        label: "Package Loss (%)",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "jitter",
        label: "Jitter (ms)",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "rtt",
        label: "RTT (ms)",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "asent",
        label: "Asent (kb)",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "arec",
        label: "Arec (kb)",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "actions",
        label: "",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
    ];
    tableData = [];
    polling = true;

    mounted() {
      this.meetingId = +this.$route.params.id || null;
      this.fetchMonitorMeetingInfoLoop();
    }

    async fetchMonitorMeetingInfoLoop() {
      do {
        try {
          const meeting = await meetingService.getDetails(this.meetingId);
          this.mid = meeting.internalMeetingId;
          this.meetingName = meeting.name;
          this.setData(await monitorService.getMonitorMeetingInfo(this.mid));

          if (['END', 'CANCEL'].includes(meeting.status)) {
            this.polling = false;
          }
          this.initLoading = false;

        } catch (e) {
          this.alertMessage = e.response?.data?.code || e.code;
        }
        await util.delay(5000);
      } while (this.polling);
    }


    setData(rawMonitorMeetingData) {
      const oldData = this.tableData;

      // first row
      this.tableData = [{
        uid: "avg",
        uname: null,
        loss: rawMonitorMeetingData.avgLoss,
        jitter: rawMonitorMeetingData.avgJitter,
        rtt: rawMonitorMeetingData.avgRTT,
        asent: rawMonitorMeetingData.avgSent,
        arec: rawMonitorMeetingData.avgRec,
      }];

      // already seen users
      for (let oldIndex = 1; oldIndex < oldData.length; oldIndex++) {
        const u = oldData[oldIndex];

        // find corresponding user info in new data
        const newIndex = rawMonitorMeetingData.listUser.findIndex(newU => newU.uid === u.uid);
        if (newIndex >= 0) {
          const newU = rawMonitorMeetingData.listUser[newIndex];
          Object.assign(u, newU);
          rawMonitorMeetingData.listUser.splice(newIndex, 1);
        }

        this.tableData.push(u);
      }

      // new users
      this.tableData.push(...rawMonitorMeetingData.listUser);
    }


    destroyed() {
      this.polling = false;
    }

  }
</script>
